// extracted by mini-css-extract-plugin
module.exports = {"imprintPage":"ImprintPage_imprintPage__3Nzke","imprintList":"ImprintPage_imprintList__3ydvh"};